(() => {
  const BTN_SELECTOR = ".shop-mobile-topbar__filters";
  const BACKDROP_SELECTOR = "[data-filter-backdrop]";
  const CLOSE_SELECTOR = "[data-filter-close]";
  const OPEN_CLASS = "filters-open";

  // Prevent multiple init bindings if Shopify reloads the section
  if (window.__shopMobileFiltersInit) return;
  window.__shopMobileFiltersInit = true;

  function setExpanded(isOpen) {
    const btn = document.querySelector(BTN_SELECTOR);
    if (btn) btn.setAttribute("aria-expanded", isOpen ? "true" : "false");
  }

  function open() {
    document.body.classList.add(OPEN_CLASS);
    setExpanded(true);
  }

  function close() {
    document.body.classList.remove(OPEN_CLASS);
    setExpanded(false);
  }

  document.addEventListener("click", (e) => {
    if (e.target.closest(BTN_SELECTOR)) {
      e.preventDefault();
      document.body.classList.contains(OPEN_CLASS) ? close() : open();
      return;
    }

    if (e.target.closest(BACKDROP_SELECTOR) || e.target.closest(CLOSE_SELECTOR)) {
      e.preventDefault();
      close();
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") close();
  });
})();



